var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.cvcCode,
      expression: "cvcCode"
    }],
    class: {
      'invalid': !_vm.isValid
    },
    attrs: {
      "id": _vm.inputId,
      "title": _vm.$t('enter.card.cvc'),
      "type": "password",
      "placeholder": "***",
      "maxlength": "3",
      "autocomplete": "cc-csc",
      "inputmode": "numeric",
      "data-private": ""
    },
    domProps: {
      "value": _vm.cvcCode
    },
    on: {
      "focus": _vm.checkReset,
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.cvcCode = $event.target.value;
      }, _vm.checkNum],
      "blur": _vm.checkLength,
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "delete", [8, 46], $event.key, ["Backspace", "Delete", "Del"])) { return null; }
        return _vm.onDelete($event);
      }
    }
  }), _c('label', {
    attrs: {
      "for": _vm.inputId
    }
  }, [_c('span', [_vm._v("CVC/CVV")])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }